export function ChipRow({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  return <div className={`flex min-w-0 flex-wrap gap-2 ${className}`}>{children}</div>;
}

const tones = {
  paper: 'bg-surface-alt text-ink border-line',
  navy: 'bg-navy text-sand border-navy',
  brass: 'bg-brass-tint text-navy-dark border-brass/35',
  success: 'bg-success-bg text-success border-success/25',
  alert: 'bg-alert-bg text-alert border-alert/25',
  line: 'bg-surface text-muted border-line',
};

export function Chip({
  children,
  tone = 'paper',
}: {
  children: React.ReactNode;
  tone?: 'paper' | 'navy' | 'brass' | 'success' | 'alert' | 'line';
}) {
  return (
    <span className={`inline-flex max-w-full items-center rounded-chip border px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide ${tones[tone]}`}>
      {children}
    </span>
  );
}

export function SelectableChip({
  children,
  selected,
  disabled,
  onClick,
}: {
  children: React.ReactNode;
  selected: boolean;
  disabled?: boolean;
  onClick: () => void;
}) {
  const tone = disabled ? 'line' : selected ? 'navy' : 'paper';
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={`inline-flex max-w-full whitespace-normal break-words rounded-chip border px-2.5 py-1.5 text-left text-[11px] font-semibold leading-snug tracking-wide disabled:opacity-60 ${tones[tone]}`}
    >
      {children}
    </button>
  );
}
